const MeasureHistory = function () {

var Report = document.getElementById("report");

    function SelectDeviceOptions(index, len) {
        for (var i = 0; i < len; i++)
            document.getElementById("Account" + i).style.display = "none";
        document.getElementById("Account" + index).style.display = "block";
        return true;
    }

    function ResizePlaceHolder(len) {
        var div = document.getElementById("PlaceHolder");
        if (div.style.height === "0px") {
            len = len - 6;
            if (len > 0)
                div.style.height = (len * 40) + "px";
        }
        else
            div.style.height = "0px";
        return true;
    }

    function GetReport() {
        // Проверка даты начала периода.
        var dpDateBegin = document.getElementById("dateBegin");
        var dpDateEnd = document.getElementById("dateEnd");
        var strBegin = dpDateBegin.value;
        if (strBegin === "") {
            dpDateBegin.value = "Не выбрано начало периода";
            return false;
        }
        // Проверка даты окончания периода.
        var strEnd = dpDateEnd.value;
        if (strEnd === "") strEnd = dpDateEnd.value = strBegin;
        var dateBegin = new Date(ConvertDate(strBegin));
        var dateEnd = new Date(ConvertDate(strEnd));
        if (dateEnd < dateBegin) {
            dpDateEnd.value = "Дата меньше начала периода";
            return false;
        }
        // Запрос АПИ.
        var SelectAccount = document.getElementById("SelectAccount");
        var SelectDevice = document.getElementById("SelectDevice" + SelectAccount.selectedIndex);
        var url = '/UL/equipment/GetMeasureHistory'
            + "/" + DateToCsharp(dateBegin)
            + "/" + DateToCsharp(dateEnd)
            + "/" + SelectAccount.value
            + "/" + SelectDevice.value
            + "/" + document.getElementById("SelectStatus").value;

        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'text';
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                Report.innerHTML = "<h4>Ожидайте загрузки данных по приборам учета</h4>";
                return;
            }
            if (xhr.status >= 200 && xhr.status < 300) 
                PrintReport(JSON.parse(xhr.response));
            else
                Report.innerHTML = "<h3 style='color: red'>Ошибка: " + xhr.status + ' ' + xhr.statusText + "</h3>";
        };
        xhr.send();
        return true;
    }

    function StatusMapping(omnisStatus) {
        if (omnisStatus) {
            if (omnisStatus == "Переданы") return "Переданы"; 
            if (omnisStatus == "Дост") return "Приняты"; 
            if (omnisStatus == "Недост") return "Не приняты"; 
            if (omnisStatus == "Брак") return "Не приняты. Брак"; 
        }
        return "";
    }

    function measureSourceMapping(measureSource) {
        if (measureSource) {
            if (measureSource == "Кабинет контрагента") {
                return "Личный кабинет";
            }
            else {
                return measureSource;
            }
        }
        return "";
    }

    function formatDate (value) {
        if (value) {
            var d = value.substring(8, 10);
            var m = value.substring(5, 7);
            var y = value.substring(0, 4);
            return d + "." + m + "." + y;
        }
    }

    // Вывод отчёта. 
    function PrintReport(result) {
        var address = "";
        var accountNumber = "";
        var innerText = "";
        var innerRows = "";
        Report.innerHTML = "";
        var ignoreStatus = ['Сброс', 'Реверс'];
        var history_section_block = document.getElementById("history_section_block").innerHTML;
        var history_item_line = document.getElementById("history_item_line").innerHTML;
        var item_status = document.getElementById("item_status").innerHTML;
        for (var i = 0; i < result.length; i++) {
            if (result[i].readingStatus && ignoreStatus.indexOf(result[i].readingStatus) !== -1)
                continue;
            
            if ((accountNumber !== result[i].accountNumber) || (address !== result[i].addressShort)) {
                Report.innerHTML = Report.innerHTML.replace("template-row", innerRows);
                innerRows = "";
            }
            innerRows += history_item_line;
            innerRows = innerRows.replace("template-type-pu", result[i].deviceType);
            innerRows = innerRows.replace("template-number-pu", result[i].deviceNumber);
            innerRows = innerRows.replace("template-indication", result[i].reading);
            innerRows = innerRows.replace("template-rate-m3", result[i].consM3).replace("null", "-");
            innerRows = innerRows.replace("template-rate-gcal", result[i].consGkal);
            var date = formatDate(String(result[i].date));
            date = (date.length > 10) ? date.substr(0, 10) : date;
            innerRows = innerRows.replace("template-transmited", date);
            innerRows = innerRows.replace("template-src", measureSourceMapping(result[i].measureSource));
            innerRows = innerRows.replace("template-status", StatusMapping(result[i].readingStatus)).replace("null", "-");
            if (result[i].readingComments)
                if ((result[i].measureSource == "Кабинет контрагента" || result[i].measureSource == "Личный кабинет") && (result[i].readingStatus == "Недост")) {
                    innerRows += item_status.replace("template-comments", result[i].readingComments);
                }
            if (address !== result[i].addressShort) {
                Report.innerHTML += "<div class='pay-history__subhead block h4'>" + result[i].addressShort  + "</div>";
                address = result[i].addressShort;
                accountNumber = "";
            }
            if (accountNumber !== result[i].accountNumber) {
                accountNumber = result[i].accountNumber;
                innerText = history_section_block;
                innerText = innerText.replace("template-accountNumber", result[i].accountNumber);
                Report.innerHTML += innerText;
            }
        }
        Report.innerHTML = Report.innerHTML.replace("template-row", innerRows);
        document.getElementById("PlaceHolder").style.height = "0px";
        return true;
    }

    function ConvertDate(date) {
        var monthYear = date.split(" ");
        var namesRu = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
        var namesEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        for (var i = 0; i <= namesRu.length; i++) {
            if (monthYear[0].toLowerCase() === namesRu[i].toLowerCase()) {
                monthYear[0] = namesEn[i];
                break;
            }
        }
        return "1 " + monthYear[0] + " " + monthYear[1];
    }

    function DateToCsharp(date) {
        var str = (date.getYear() + 1900) + "-";
        if (date.getMonth() < 9)
            str += "0";
        str += (date.getMonth() + 1) + "-";
        if (date.getDate() < 10)
            str += "0";
        str += date.getDate();
        return str;
    }
    return {
        SelectDeviceOptions: SelectDeviceOptions,
        ResizePlaceHolder: ResizePlaceHolder,
        GetReport: GetReport
    };
}();
export {
    MeasureHistory
};



// WEBPACK FOOTER //
// ./wwwroot/app/UL/MeasureHistory.js